export default __webpack_public_path__ + "static/media/GIB.4e10d11d.svg";